// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"Home_mainContainer__37O97"};